export default __webpack_public_path__ + "static/media/SOLAR_THIRD_PARTY.70499341.svg";